
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/on-demand-app-development",
      function () {
        return require("private-next-pages/on-demand-app-development/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/on-demand-app-development"])
      });
    }
  